export default __webpack_public_path__ + "static/media/taxactindia1.e2bb03f8.png";